import React from "react";
import { WebinarsExpertBox } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { renderRichText } from "@/lib/richText";
import Image from "next/image";
import VideoPlayer from "@/components/VideoPlayer";

interface WebinarsExpertProps {
  blok?: WebinarsExpertBox & SbBlokData;
}

const WebinarsExpertComponent: React.FC<WebinarsExpertProps> = ({ blok }) => {

  if (!blok) return null;

  const { title, description, items } = blok;

  return (
    <div {...storyblokEditable(blok)} className="container pb-5">
      <div className="row justify-content-center gy-4 gy-md-0">
        <div className="col-md-12 col-lg-13 col-xl-14 col-xxl-16">
          <h3>{title}</h3>
          <p className="mb-3">{description}</p>

          {items?.[0]?.video_tag && (
            <VideoPlayer videoId={items?.[0]?.video_tag} />
          )}


          <ul className="list-unstyled">
            {items?.map((expert) => (
              <li key={expert._uid} className="event-speaker-bio mb-4">
                <div className="event-speaker-bio-img">
                  {expert.image?.filename && (
                    <Image
                      src={expert.image.filename}
                      alt={expert.image.alt || `${expert.name} – Bulletproof`}
                      title={`${expert.name} – Bulletproof`}
                      width={140}
                      height={140}
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                      loading="lazy"
                      quality={75}
                    />
                  )}
                </div>
                <div className="event-speaker-bio-content">
                  <div className="mb-3 mb-lg-4">
                    <h3>{expert.name}</h3>
                    <span className="text-primary">{expert.position}</span>
                  </div>
                  {expert.body && (
                    <div
                      dangerouslySetInnerHTML={{ __html: renderRichText(expert.body) }}
                    />
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WebinarsExpertComponent;